import { repeat } from 'owa-locstrings/lib/strings/repeat.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import type ColorScheme from 'owa-color-utils/lib/ColorScheme';
import generateDefaultDropdownStyles from 'owa-component-styling-utils/lib/utils/colorSchemesToStyles/generateDefaultDropdownStyles';
import generateDropdownCalloutStyles from 'owa-component-styling-utils/lib/utils/generateDropdownCalloutStyles';

import { Dropdown, IDropdownOption } from '@fluentui/react/lib/Dropdown';
import type { RecurrenceTypes } from 'owa-recurrence-utils/lib/RecurrenceTypes';

export interface RecurrenceMenuProps extends React.HTMLProps<HTMLDivElement> {
    recurrenceMenuItems: IDropdownOption[];
    currentRecurrenceString: string;
    currentRecurrenceKey: string;
    onRecurrenceChangedCallback: (recurrenceType: RecurrenceTypes) => void;
    colorScheme?: ColorScheme;
    className?: string;
    disabled?: boolean;
}

export default function RecurrenceMenu(props: RecurrenceMenuProps) {
    const onRenderTitle = (item: IDropdownOption | IDropdownOption[]): JSX.Element => {
        return <span>{props.currentRecurrenceString}</span>;
    };
    /**
     * Callback issued when the menu item is selected
     */
    const onChange = (
        ev: React.FormEvent<HTMLDivElement>,
        option?: IDropdownOption,
        index?: number
    ) => {
        if (option && props.onRecurrenceChangedCallback) {
            props.onRecurrenceChangedCallback(option.key as RecurrenceTypes);
        }
    };
    return (
        <Dropdown
            className={props.className}
            label={loc(repeat)}
            options={props.recurrenceMenuItems}
            selectedKey={props.currentRecurrenceKey}
            onChange={onChange}
            notifyOnReselect={true}
            calloutProps={{ styles: generateDropdownCalloutStyles(), gapSpace: 5 }}
            onRenderTitle={onRenderTitle}
            styles={generateDefaultDropdownStyles(props.colorScheme)}
            disabled={props.disabled}
        />
    );
}
